import * as auth from '@utils/auth';

export const parseApiError = async ({ error, defaultMessage }) => {
  if (!error) return null;

  if (defaultMessage && process.env.NODE_ENV === 'production') {
    error.message = defaultMessage;
  }

  if (error.response?.status === 401) {
    // FIXME: will loose all form values
    auth.signIn();
  }

  if (error.response?.headers.get('content-type')?.includes('json')) {
    const json = await error.response.clone().json();
    console.error(json);
    error.json = json;
  }

  return error;
};
